import { ModelInstance, ToFrontHook, ToBackHook, BaseModel, DateField } from './util';
import { File } from './file';
import { Sport, SportTypes } from './sport';
import { User } from './user';
import { City } from './city';

@ModelInstance({
  mappingFields: {
    id: 'id',
    name: 'name',
    sport: 'sport',
    logo: 'logo',
    owner: 'owner',
    city: 'city',
    users_count: 'usersCount',
    won_games_count: 'wonGamesCount',
    games_count: 'gamesCount',
    score_sum: 'scoreSum',
    closest_game_datetime: 'closestGameDatetime',
    created_by_league_id: 'createdByLeagueId',
    unique_code: 'uniqueCode',
  },
  relation: {
    sport: Sport,
    logo: File,
    owner: User,
    city: City,
    closestGameDatetime: DateField,
  }
})
export class Team extends BaseModel {
  id: number;
  name: string;
  sport: Sport;
  logo: File;
  owner: User;
  city: City;
  usersCount: number;
  wonGamesCount: number;
  gamesCount: number;
  scoreSum: number;
  closestGameDatetime: Date;
  createdByLeagueId: number;
  uniqueCode: string;

  getEmptyLogoClass(): string {
    const classList = ['empty-logo'];
    if (this.sport.isBasketball()) {
      classList.push('empty-logo-basketball');
    }
    if (this.sport.isVolleyball()) {
      classList.push('empty-logo-volleyball');
    }
    if (this.sport.isHockey()) {
      classList.push('empty-logo-hockey');
    }
    if (this.sport.isFootball()) {
      classList.push('empty-logo-football');
    }
    if (this.sport.isHandball()) {
      classList.push('empty-logo-handball');
    }
    if (this.sport.isRugby()) {
      classList.push('empty-logo-rugby');
    }
    if (this.sport.isWaterpolo()) {
      classList.push('empty-logo-waterpolo');
    }
    if (this.sport.isWrestball()) {
      classList.push('empty-logo-basketball');
    }
    if (this.sport.id === SportTypes.chess) {
      classList.push('empty-logo-chess');
    }
    if (this.sport.id === SportTypes.table_tennis) {
      classList.push('empty-logo-table-tennis');
    }
    if (this.sport.id === SportTypes.billiard) {
      classList.push('empty-logo-billiard');
    }
    if (this.sport.id === SportTypes.darts) {
      classList.push('empty-logo-darts');
    }
    if (this.sport.id === SportTypes.badminton) {
      classList.push('empty-logo-badminton');
    }
    if (this.sport.id === SportTypes.padel_tennis) {
      classList.push('empty-logo-padel-tennis');
    }
    if (this.sport.id === SportTypes.other_dota) {
      classList.push('empty-logo-dota');
    }
    if (this.sport.id === SportTypes.other_fifa) {
      classList.push('empty-logo-fifa');
    }
    return classList.join(' ');
  }

  @ToFrontHook
  static toFront(data: any): any {
    return null;
  }

  @ToBackHook
  static toBack(team: Team): any {
    return null;
  }
}
